


import React, { useMemo } from "react";
import {
  StopOutlined,
  RobotOutlined,
  GlobalOutlined,
  CheckCircleOutlined,
  DatabaseOutlined,
  DollarOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import { abbreviateNumber } from "../../utils/commonFunctions";
import "../../scss/cardItem.scss";

const CardItem = ({ dashboardData, currentRole }) => {
  const cardData = useMemo(() => {
    if (!dashboardData) return [];
    const totalCost = Number(dashboardData?.total_cost || 0);
    const formattedCost =totalCost < 1 ? `$${totalCost.toFixed(3)}` : `$${abbreviateNumber(totalCost, 1)}`;


    // Common stats (both roles see these)
    const baseStats = [
      {
        name: "Total Tenant",
        value: abbreviateNumber(Number(dashboardData?.total_organizations || 0), 1),
        icon: <RobotOutlined className="f25" />,
      },
      {
        name: "Total Bots",
        value: abbreviateNumber(Number(dashboardData?.total_bots || 0), 1),
        icon: <StopOutlined className="f25" />,
      },
      {
        name: "Queries Answered",
        value: abbreviateNumber(Number(dashboardData?.total_queries_answered || dashboardData?.queries_answered || 0), 1),
        icon: <CheckCircleOutlined className="f25" />,
      },
      {
        name: "Total Tokens",
        value: abbreviateNumber(Number(dashboardData?.total_tokens ||dashboardData.token_usage || 0), 1),
        icon: <DatabaseOutlined className="f25" />,
      },
      {
        name: "Total Cost",
        value:formattedCost,
        // value: `$${abbreviateNumber(Number(dashboardData?.total_cost || 0), 1)}`,
        icon: <DollarOutlined className="f25" />,
      },
      {
        name: "Unique LLM Models",
        value: abbreviateNumber(Number(dashboardData?.total_unique_llm_models || 0), 1),
        icon: <AppstoreOutlined className="f25" />,
      },
    ];

    // Admin-only stats
    if (currentRole === "admin") {
      return [
        {
          name: "Total Organizations",
          value: abbreviateNumber(Number(dashboardData?.total_organizations || 0), 1),
          icon: <GlobalOutlined className="f25" />,
        },
        ...baseStats,
      ];
    }

    // Tenant sees only base stats
    return baseStats;
  }, [dashboardData, currentRole]);

  return (
    <div className="project-insights-container mt20 mb20">
      <Row className="items-container item-i-cb fw">
        {cardData?.map((card) => (
          <Col
            key={card?.name}
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={4}
            style={{ padding: "6px" }}
          >
            <div className="card pri-box-shadow">
              <Row align="middle" justify="space-between" wrap={false}>
                <Col>
                  <p>{card?.value}</p>
                  <span
                    style={{ position: "relative" }}
                    className="whitespace-nowrap"
                  >
                    {card?.name}
                  </span>
                  {card?.subName && (
                    <>
                      <br />
                      <span
                        style={{
                          position: "absolute",
                          bottom: -16,
                          fontStyle: "italic",
                        }}
                        className="whitespace-nowrap"
                      >
                        {card?.subName}
                      </span>
                    </>
                  )}
                </Col>
                {card?.icon}
              </Row>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default CardItem;

